export default "__VITE_ASSET__Br40iUDM__"